export default {"src":"/_next/static/media/property-news-logo-white.98e97af6.svg","height":33,"width":240,"blurWidth":0,"blurHeight":0};